/* eslint-disable */ import { attachSingleReferenceComponent, dimensionIndicatorComponent, memoEval, referenceComponent, sidebarTabsComponent, violationComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { AnchorPoint } from '../model/index.js';
export const holeComponents = [
    attachComponent.withComponent(violationComponent, 'default', true).withAlias('Hole').attach(memoEval((s)=>[
            s.$violations
        ], (violations)=>{
        return {
            violations
        };
    })),
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'Hole.$anchorPointFrom', true).withAlias('Hole'), AnchorPoint, 'anchorPointFromId'),
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'Hole.$anchorPointTo', true).withAlias('Hole'), AnchorPoint, 'anchorPointToId'),
    attachComponent.withComponent(sidebarTabsComponent, 'default', true).withAlias('Hole').attach(memoEval(()=>[], ()=>({
            tabs: [
                {
                    label: 'Plate',
                    navigationStates: [
                        'Dimensions'
                    ]
                },
                {
                    label: 'Add/Edit Features',
                    navigationStates: [
                        'Features'
                    ]
                },
                {
                    label: 'All Features',
                    navigationStates: [
                        'FeatureList'
                    ]
                }
            ]
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'positionX', true).withAlias('Hole').withFilter(()=>({
            navigationStates: [
                'Features',
                'FeatureList',
                'BulkFinalization',
                'Finalization'
            ],
            toolStates: [
                'Configure'
            ]
        })).attach(memoEval((self)=>[
            self.$positionXIndicatorStartX,
            self.$positionXIndicatorEndX,
            self.$positionXIndicatorStartY,
            self.$positionXIndicatorEndY,
            self.$positionXIndicatorStartZ,
            self.$positionXIndicatorEndZ,
            self.$positionXIndicatorExtrusionY,
            self.$positionXIndicatorExtrusionZ,
            self.$positionIndicatorLabelFontSize
        ], ($positionXIndicatorStartX, $positionXIndicatorEndX, $positionXIndicatorStartY, $positionXIndicatorEndY, $positionXIndicatorStartZ, $positionXIndicatorEndZ, $positionXIndicatorExtrusionY, $positionXIndicatorExtrusionZ, $positionIndicatorLabelFontSize)=>({
            startX: $positionXIndicatorStartX,
            endX: $positionXIndicatorEndX,
            startY: $positionXIndicatorStartY,
            endY: $positionXIndicatorEndY,
            startZ: $positionXIndicatorStartZ,
            endZ: $positionXIndicatorEndZ,
            extrusionY: $positionXIndicatorExtrusionY,
            extrusionZ: $positionXIndicatorExtrusionZ,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $positionIndicatorLabelFontSize
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'positionY', true).withAlias('Hole').withFilter(()=>({
            navigationStates: [
                'Features',
                'FeatureList',
                'BulkFinalization',
                'Finalization'
            ],
            toolStates: [
                'Configure'
            ]
        })).attach(memoEval((self)=>[
            self.$positionYIndicatorStartX,
            self.$positionYIndicatorEndX,
            self.$positionYIndicatorStartY,
            self.$positionYIndicatorEndY,
            self.$positionYIndicatorStartZ,
            self.$positionYIndicatorEndZ,
            self.$positionYIndicatorExtrusionX,
            self.$positionYIndicatorExtrusionZ,
            self.$positionIndicatorLabelFontSize
        ], ($positionYIndicatorStartX, $positionYIndicatorEndX, $positionYIndicatorStartY, $positionYIndicatorEndY, $positionYIndicatorStartZ, $positionYIndicatorEndZ, $positionYIndicatorExtrusionX, $positionYIndicatorExtrusionZ, $positionIndicatorLabelFontSize)=>({
            startX: $positionYIndicatorStartX,
            endX: $positionYIndicatorEndX,
            startY: $positionYIndicatorStartY,
            endY: $positionYIndicatorEndY,
            startZ: $positionYIndicatorStartZ,
            endZ: $positionYIndicatorEndZ,
            extrusionX: $positionYIndicatorExtrusionX,
            extrusionZ: $positionYIndicatorExtrusionZ,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $positionIndicatorLabelFontSize
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'sizeX', true).withAlias('Hole').withFilter(()=>({
            navigationStates: [
                'Features',
                'FeatureList',
                'BulkFinalization',
                'Finalization'
            ],
            toolStates: [
                'Configure'
            ]
        })).attach(memoEval((self)=>[
            self.$sizeXIndicatorStartX,
            self.$sizeXIndicatorEndX,
            self.$sizeXIndicatorStartY,
            self.$sizeXIndicatorEndY,
            self.$sizeXIndicatorStartZ,
            self.$sizeXIndicatorEndZ,
            self.$sizeXIndicatorExtrusionY,
            self.$sizeXIndicatorExtrusionZ,
            self.$sizeIndicatorLabelFontSize,
            self.$sizeIndicatorColor
        ], ($sizeXIndicatorStartX, $sizeXIndicatorEndX, $sizeXIndicatorStartY, $sizeXIndicatorEndY, $sizeXIndicatorStartZ, $sizeXIndicatorEndZ, $sizeXIndicatorExtrusionY, $sizeXIndicatorExtrusionZ, $sizeIndicatorLabelFontSize, $sizeIndicatorColor)=>({
            startX: $sizeXIndicatorStartX,
            endX: $sizeXIndicatorEndX,
            startY: $sizeXIndicatorStartY,
            endY: $sizeXIndicatorEndY,
            startZ: $sizeXIndicatorStartZ,
            endZ: $sizeXIndicatorEndZ,
            extrusionY: $sizeXIndicatorExtrusionY,
            extrusionZ: $sizeXIndicatorExtrusionZ,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $sizeIndicatorLabelFontSize,
            labelColor: $sizeIndicatorColor,
            indicatorLineColor: $sizeIndicatorColor,
            extrusionLineColor: $sizeIndicatorColor
        }))),
    attachComponent.withComponent(dimensionIndicatorComponent, 'sizeY', true).withAlias('Hole').withFilter(()=>({
            navigationStates: [
                'Features',
                'FeatureList',
                'BulkFinalization',
                'Finalization'
            ],
            toolStates: [
                'Configure'
            ]
        })).attach(memoEval((self)=>[
            self.$sizeYIndicatorStartX,
            self.$sizeYIndicatorEndX,
            self.$sizeYIndicatorStartY,
            self.$sizeYIndicatorEndY,
            self.$sizeYIndicatorStartZ,
            self.$sizeYIndicatorEndZ,
            self.$sizeYIndicatorExtrusionX,
            self.$sizeYIndicatorExtrusionZ,
            self.$sizeIndicatorLabelFontSize,
            self.$sizeIndicatorColor
        ], ($sizeYIndicatorStartX, $sizeYIndicatorEndX, $sizeYIndicatorStartY, $sizeYIndicatorEndY, $sizeYIndicatorStartZ, $sizeYIndicatorEndZ, $sizeYIndicatorExtrusionX, $sizeYIndicatorExtrusionZ, $sizeIndicatorLabelFontSize, $sizeIndicatorColor)=>({
            startX: $sizeYIndicatorStartX,
            endX: $sizeYIndicatorEndX,
            startY: $sizeYIndicatorStartY,
            endY: $sizeYIndicatorEndY,
            startZ: $sizeYIndicatorStartZ,
            endZ: $sizeYIndicatorEndZ,
            extrusionX: $sizeYIndicatorExtrusionX,
            extrusionZ: $sizeYIndicatorExtrusionZ,
            extrusionLineDashed: true,
            dashScale: 500,
            arrowHeadType: 'CONE',
            arrowHeadSize: 6,
            labelFontSize: $sizeIndicatorLabelFontSize,
            labelColor: $sizeIndicatorColor,
            indicatorLineColor: $sizeIndicatorColor,
            extrusionLineColor: $sizeIndicatorColor
        })))
];

//# sourceMappingURL=hole.js.map